export const STOCK_FETCH_SUCCESS = 'STOCK_FETCH_SUCCESS';
export const STOCK_FETCH_ERROR = 'STOCK_FETCH_ERROR';
export const STOCK_REMOVE_DATA = 'STOCK_REMOVE_DATA';
